import axios from 'axios';

async function VerificarSocio(dniSocio: string) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/verificar_socio"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "socio": {
                "dni": dniSocio
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default VerificarSocio;